<div class="card settings-page">
  <div class="action-panel">
    <app-search-input
      placeholder="Search"
      [searchDelayTime]="0"
      [formControl]="searchControl"
    />
  </div>

  <div class="card-body">
    @if (!isLoading()) {
      <app-list-grid-client-side
        [rowData]="filteredTemplatesList()"
        [colDefs]="$any(colDefs)"
        [rowSelection]="emailTemplatesRowSelection"
        [suppressRowClickSelection]="true"
        [paginationPageSizeSelector]="true"
        [suppressCellFocus]="true"
      />
    }

    <app-loader [loading]="isLoading()"/>
  </div>
</div>
